import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function MapSizeObserver() {
  const map = useMap();
  useEffect(() => {
    if (typeof ResizeObserver !== 'function') return undefined;
    let frame = null;
    let active = true;
    const update = () => {
      if (!active || frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        map.invalidateSize({ pan: false, debounceMoveend: true });
      });
    };
    const observer = new ResizeObserver(update);
    observer.observe(map.getContainer());
    update();
    return () => { active = false; observer.disconnect(); if (frame !== null) window.cancelAnimationFrame(frame); };
  }, [map]);
  return null;
}
